import { Component, Input, signal, Signal } from '@angular/core';
import { IResearchOverviewItem } from '~global-interfaces/IResearchOverviewItem';

import { ButtonDownloadPdfComponent } from '~features/pdfAnalytics/button-download-pdf/button-download-pdf.component';
import { TrackDownloadDirective } from '~features/user-behavior-analytics/directives';
import { DateComponent } from '~shared/components/ui/date/date.component';

@Component({
  selector: 'app-research-list',
  imports: [DateComponent, ButtonDownloadPdfComponent, TrackDownloadDirective],
  templateUrl: './research-list.component.html',
})
export class ResearchListComponent {
  @Input() researchOverviewList: Signal<IResearchOverviewItem[] | null> = signal(null);
}
